import { useMutation } from '@tanstack/react-query';
import { ApiError } from '@src/services/api';
import { CollectionView } from 'common';
import { DEPRECATED_QUERY_KEYS, queryClient } from '@src/query';
import { createCollection } from './api';
import { setQueryCollections } from './useQueryCollections';

export const useMutationCollectionCreate = () => useMutation<CollectionView, ApiError, Pick<CollectionView, 'name' | 'description' | 'category'>>({
  mutationFn: (partialCollection) => createCollection({
    name: partialCollection.name,
    desc: partialCollection.description,
    category: partialCollection.category,
  }),
  onSuccess: async (newCollection) => {
    const current = queryClient.getQueryData<CollectionView[]>([DEPRECATED_QUERY_KEYS.COLLECTIONS]) ?? [];
    setQueryCollections([newCollection, ...current]);
    queryClient.invalidateQueries({ queryKey: [DEPRECATED_QUERY_KEYS.COLLECTIONS] });
  },
});
